import React from "react";
import { BRAND } from "@/lib/api";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="hb-hero-frame text-white py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="text-xs tracking-[0.35em] uppercase text-white/60 mb-4">Family Owned · New York Made</div>
          <h1 className="font-display text-6xl sm:text-7xl">The Hampton Blu Story</h1>
          <p className="mt-6 text-white/80 leading-relaxed">United in purpose. Built on family. Empowering futures.</p>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-6 py-20">
        <img src={BRAND.logo} alt="Hampton Blu emblem" className="w-40 mx-auto mb-10" />
        <p className="text-lg text-neutral-700 leading-relaxed">
          Hampton Blu Creations is a family-run brand born from a love of New York sports, doodle dogs, and doing things <em>the right way</em>.
          Every design is drawn with intention, printed on premium apparel, and made to be worn with pride.
        </p>
        <p className="mt-6 text-lg text-neutral-700 leading-relaxed">
          Whether you're rocking the One United movement, repping the Doodle Crew, or wearing a custom piece we designed just for you — you're part of the family now.
        </p>
        <p className="mt-6 text-lg font-serif-editorial text-[color:var(--hb-navy)] italic">
          Thank you for your business. We hope you enjoy.
        </p>
      </section>
    </div>
  );
}
